import { useTranslation } from 'react-i18next'
import { ReactComponent as FlixxoSVG } from 'assets/brand/avatar.svg'
import ModalTemplate from '../components/ModalTemplate/index'
import {
  Button,
  ButtonOpenApp,
  Card,
  Div,
  Text
} from 'ui'
import { useModal } from 'hooks'
import styled from 'styled-components'


const Container = styled.div`
  place-self: end center;
  animation: move-up 1s ease forwards;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  @keyframes move-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0%);
    }
  }
`


const DownloadApp = () => {

  const { t } = useTranslation()
  const { Modal } = useModal()

  return (
    <Container>
      <ModalTemplate hideClose minHeight='fit-content' width='100%'>
        <Text color='headline' size='xl' align='center'>
          {t('enjoyFullExperience')}
        </Text>

        <Div width='100%' marginTop={32} marginBottom={26}>
          <Card variant='secondary'>
            <Div
              padding={12}
              display='flex'
              gap={8}
              alignItems='center'
            >
              <FlixxoSVG width={32} height={32} />
              <Div flexGrow={1}>
                <Text color='headline'>
                  Flixxo app
                </Text>
              </Div>

              <Div width={80}>
                <ButtonOpenApp>
                  {t('open')}
                </ButtonOpenApp>
              </Div>
            </Div>
          </Card>
        </Div>

        <Div marginBottom={20}>
          <Button variant='tertiary' onClick={Modal.close}>
            <Text size='sm' weight='medium' color='headline'>
              {t('continueOnBrowser')}
            </Text>
          </Button>
        </Div>
      </ModalTemplate>
    </Container>
  )
}

export default DownloadApp